






import { Component, Prop, Vue } from 'vue-property-decorator';
import { ReportBlock } from './ReportBlock';
import { DataType } from '@/core/data/DataType';

import StatEnterExitFilter from '../stats/StatEnterExitFilter.vue';
import TableEnterExit from '../tables/TableEnterExit.vue';
import { EnterExitColoredRecord } from '@/core/data/sets/computed/EnterExitColoredRecord';


@ReportBlock("Вход и выход", '<i class="fas fa-door-open"></i>',  [DataType.EnterExitDaily, DataType.EnterExitHourly])
@Component ({
  components: {
    StatEnterExitFilter,
    TableEnterExit,
  }
})
export default class extends Vue {
  public filteredDates: string[] = EnterExitColoredRecord.getAllDates();
  public filteredPlaces: string[] = EnterExitColoredRecord.getAllPlaces();
}

